<template>

  <div id="app">
    <v-app id="inspire">
      <v-layout align-center justify-center>

        <v-snackbar
          :value="$store.getters.error"
          color="error"
          :top="true"
          :multi-line="true"
          :auto-height="true"
          :timeout="6000"
          :vertical="false"
        >
          <m-pay-error-message :error="$store.getters.error" :login="true"/>
          <v-btn dark flat @click="clearMessages">
            Close
          </v-btn>
        </v-snackbar>

        <v-flex xs12 sm8 md4>
          <v-card class="elevation-3 pb-3">

            <div>
              <v-toolbar dark color="primary">
                <v-toolbar-title>Password Expired</v-toolbar-title>
              </v-toolbar>

              <div>
                <div class="my-3 mx-3 subheading">
                  Your password has expired and needs to be renewed. Please enter your new password.
                </div>
                <m-pay-password-form
                  :loading="loading"
                  :submit-callback="renewPassword"
                  button-label="Renew Password"
                ></m-pay-password-form>
              </div>

            </div>

          </v-card>
        </v-flex>

      </v-layout>
    </v-app>
  </div>

</template>

<script>
import axios from 'axios';
import queries from '../../utils/queries';
import MPayErrorMessage from '../MPayErrorMessage';
import MPayPasswordForm from '../MPayPasswordForm';

export default {
  components: { MPayPasswordForm, MPayErrorMessage },
  data: () => ({
    loading: false,
  }),
  methods: {
    renewPassword(password) {
      this.loading = true;
      this.clearMessages();
      axios.post(queries.renewPassword(), {
        newPassword: password,
      })
        .then(() => {
          this.loading = false;
          this.$store.dispatch('renewPassword');
          this.$router.replace({ name: 'home' });
        })
        .catch((e) => {
          this.loading = false;
          this.showError(e);
        });
    },
  },
};

</script>



// WEBPACK FOOTER //
// src/components/login/MPayPasswordRenewal.vue